import React, { Component } from 'react'
import { Grid ,Icon} from 'semantic-ui-react'
import map_icon from '../../assets/images/newui/map-view-icon.svg';
import './DisplayDistanceNew.less'


const initialState = {
    showDistanceDetails: true,
    from: '',
    to: '',
    distance: '',
    duration: ''
};

class DisplayDistance extends Component {

    constructor(props){
        super(props);
        this.state = initialState;
        console.log('in display distance', props)
    }

    processDistance = (distance) => {
        this.setState({
            from: distance.sourceAddress,
            to: distance.destinationAddress           
        })

        if(_.includes(Object.keys(distance), 'distance') && !_.isEmpty(distance.distance)){
            this.setState({distance: distance.distance.text})
        }

        if(_.includes(Object.keys(distance), 'duration') && !_.isEmpty(distance.duration)){
            this.setState({duration: distance.duration.text})
        }
    }

    componentDidMount(){
        if(this?.props?.sbr?.postProcessing?.distance && !_.isEmpty(this.props.sbr.postProcessing.distance)){
            this.processDistance(this.props.sbr.postProcessing.distance);
            this.setState({showDistanceDetails: true});
            //this.props.isDistanchShow(true);
        }
        else{
            this.setState({showDistanceDetails: false});
            //this.props.isDistanchShow(false);
        }
    }

    componentDidUpdate(prevProps){
        if(prevProps?.sbr?.singleBuyerRequestID != this?.props?.sbr?.singleBuyerRequestID){
            console.log(this.props.sbr);
            if(this?.props?.sbr?.postProcessing?.distance && !_.isEmpty(this.props.sbr.postProcessing.distance)){
                this.processDistance(this.props.sbr.postProcessing.distance);
                this.setState({showDistanceDetails: true});
                //this.props.isDistanchShow(true);
            }
            else{
                this.setState({showDistanceDetails: false});
                //this.props.isDistanchShow(false);
            }
        }       
    }

    createLink = () => {
        const from = this.state.from.replace(' ', '+');
        const to = this.state.to.replace(' ', '+');
        
        return <a href={`https://www.google.com/maps/dir/${from}/${to}`} target="_blank">View</a>
    }

    changeLocation = async (newAddress) => {
        
        
    }
    
    render() {
        return (           
                this.state.showDistanceDetails &&
                
                
                <div className="distance-display-container-new">                  
                    
                    <Grid>
                        <Grid.Row className={"distance-container-row"}>
                            <Grid.Column width={16}>
                            {/* Estimated distance from <b>{this.state.from || "6909 wing In., La Puente"}</b> to <b>{this.state.to || "16208 sigma st, Hacienda heights"}</b> is <b className="distance">{this.state.distance || "4.7 mi"}</b> with an ETA of <b>{this.state.duration || "12 min"}</b> */}
                            <div className="estimate-container">
                                <div className="locations">
                                    <div className="location">
                                        <div className="start-pin pin">{<b>A</b>}</div>
                                        <div className='address'>{this.state.from}</div>
                                        
                                    </div>
                                    <div className="location">
                                        <div className="end-pin pin">{<b>B</b>}</div>
                                        <div className='address'>{this.state.to}</div>
                                        
                                    </div>
                                    <div className="location">       
                                    </div>          
                                </div>
                                <div className="estimate">
                                    <div className="distance">
                                        <div className={"icons_container"}>
                                            <svg id="Group_15791" data-name="Group 15791" xmlns="http://www.w3.org/2000/svg" width="20" height="11.839" viewBox="0 0 16.567 11.839">
                                            <defs>
                                                <clipPath id="clip-path">
                                                <rect id="Rectangle_8425" data-name="Rectangle 8425" width="16.567" height="11.839" fill="none"/>
                                                </clipPath>
                                            </defs>
                                            <g id="Group_15521" data-name="Group 15521" clip-path="url(#clip-path)">
                                                <path id="Path_29170" data-name="Path 29170" d="M7.59,0c0,.6.006,1.163,0,1.729-.005.343.033.4.37.4.252,0,.5,0,.757,0,.194,0,.255-.066.256-.261,0-.613,0-1.226,0-1.854.065,0,.12-.009.174-.009.993,0,1.985,0,2.978,0a.2.2,0,0,1,.224.149q2.067,5.735,4.142,11.466c.025.069.048.138.078.223H9.249c-.017-.515-.033-1.023-.05-1.531-.021-.641-.041-1.283-.065-1.924-.01-.261-.046-.3-.3-.307-.384-.01-.768-.011-1.152-.011-.171,0-.237.07-.244.262C7.415,8.9,7.4,9.473,7.38,10.045c-.021.594-.043,1.189-.066,1.793H0c.031-.089.057-.169.086-.249Q2.15,5.882,4.212.173A.213.213,0,0,1,4.453,0c.993.007,1.985,0,2.978,0ZM9.074,6.085H9.048c0-.372,0-.743,0-1.115,0-.486-.012-.973-.021-1.459,0-.2-.075-.266-.274-.267-.218,0-.435,0-.653,0-.442,0-.5-.065-.512.477-.021.978-.064,1.955-.1,2.932-.008.24.051.32.249.324q.541.011,1.083,0c.184,0,.248-.082.25-.274s0-.412,0-.618" transform="translate(0 0)"/>
                                                <path id="Path_29171" data-name="Path 29171" d="M218.881,96.842c0,.206,0,.412,0,.618s-.065.271-.25.274q-.541.01-1.083,0c-.2,0-.257-.085-.249-.324.031-.977.074-1.955.1-2.932.012-.542.071-.477.512-.477.218,0,.435,0,.653,0,.2,0,.27.07.274.267.009.486.016.973.021,1.459,0,.372,0,.743,0,1.115h.027" transform="translate(-209.806 -90.757)" fill="#fff"/>
                                            </g>
                                            </svg>
                                        </div>
                                        <div>{this.state.distance}</div>
                                    </div>
                                    {
                                        this.props.showDuration ? 
                                            <div className="eta">
                                                <div className={"icons_container"}>
                                                    <Icon name="clock outline" size="large"></Icon>
                                                </div>
                                                <div>{this.state.duration}</div>
                                            </div> : ""
                                    }   
                                    {
                                        this.props.showViewLink ? 
                                        <div className="map-link">
                                            <div className={"icons_container"}>
                                                <img src={map_icon}></img>
                                            </div>
                                            <div className={"link"}>{this.createLink()}</div>
                                        </div>  : ""
                                    }
                                            
                                </div>                                 
                            </div>                              
                            </Grid.Column>                            
                        </Grid.Row>  
                        
                    </Grid> 
                
                </div>
            
        )
    }
}

export default DisplayDistance
